import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";
import View from "../View.mjs";

export default {

    async enviaPagamentoParaFinanceiro(pagamentoEletronicoValores = {}){

        let pagamentoEletronico = {};

        try{

            pagamentoEletronicoValores = {
                ...pagamentoEletronicoValores,
                status: "Enviado para o Financeiro",
                justificativa: "",
            };

            pagamentoEletronico = await ERP.patchOne(Schema.PAGAMENTO_ELETRONICO_DE_PENSOES_ALIMENTICIAS,pagamentoEletronicoValores);
            if(pagamentoEletronico.status != 200){
                throw pagamentoEletronico;
            }

            console.log(pagamentoEletronico);

        }catch(e){

            console.log(e);
            return pagamentoEletronico;

        }

        return pagamentoEletronico;

    },

    async RHCancelaPagamento(pagamentoEletronicoValores = {}){

        let pagamentoEletronico = {};

        try{

            pagamentoEletronicoValores = {
                ...pagamentoEletronicoValores,
                status: "Cancelado pelo RH",
            };

            pagamentoEletronico = await ERP.patchOne(Schema.PAGAMENTO_ELETRONICO_DE_PENSOES_ALIMENTICIAS,pagamentoEletronicoValores);
            if(pagamentoEletronico.status != 200){
                throw pagamentoEletronico;
            }

            console.log(pagamentoEletronico);

        }catch(e){

            console.log(e);
            return pagamentoEletronico;

        }

        return pagamentoEletronico;

    },

    async financeiroReprovaPagamento(pagamentoEletronicoValores = {}){

        let pagamentoEletronico = {};

        try{

            pagamentoEletronicoValores = {
                ...pagamentoEletronicoValores,
                status: "Reprovado pelo Financeiro",
            };

            pagamentoEletronico = await ERP.patchOne(Schema.PAGAMENTO_ELETRONICO_DE_PENSOES_ALIMENTICIAS,pagamentoEletronicoValores);
            if(pagamentoEletronico.status != 200){
                throw pagamentoEletronico;
            }

            console.log(pagamentoEletronico);

        }catch(e){

            console.log(e);
            return pagamentoEletronico;

        }

        return pagamentoEletronico;

    },

    async gerarArquivoREM(pagamentoEletronicoValores = {}){

        let pagamentoEletronico = {};
        let remDados = {};
        let remArquivo = {};

        try{

            //==================================================================//
            //======= Pega Dados do Pagamento Eletronico para Gerar REM ========//
            //==================================================================//

            remDados = await ERP.getOneWithView(View.PAGAMENTOS_ELETRONICOS_DE_PENSOES_ALIMENTICIAS_GERAR_ARQUIVO_REM,[
                {
                    name: "id",
                    dataType: "String",
                    value: pagamentoEletronicoValores.id
                },
            ]);
            if(remDados.status != 200){
                throw remDados;
            }

            // console.log(remDados);

            //==================================================================//
            //======================= Cria o Arquivo REM =======================//
            //==================================================================//

            remArquivo = await ERP.createREM({
                remDados: remDados.data
            });
            if(remArquivo.status != 200){
                throw remArquivo;
            }
  
            // console.log(remArquivo);

            //==================================================================//
            //=================== Altera Pagamento Eletronico ==================//
            //==================================================================//

            pagamentoEletronicoValores = {
                ...pagamentoEletronicoValores,
                justificativa: "",
                status: "Arquivo REM gerado",
            };

            pagamentoEletronico = await ERP.patchOne(Schema.PAGAMENTO_ELETRONICO_DE_PENSOES_ALIMENTICIAS,pagamentoEletronicoValores);
            if(pagamentoEletronico.status != 200){
                throw pagamentoEletronico;
            }

            // console.log(pagamentoEletronico);

        }catch(e){

            console.log(e);
            return e;

        }

        return remArquivo;

    },

}